
import Records from "@/components/Records.vue";
import Map from "@/components/Map.vue";
import {defineComponent} from 'vue';
import {checkUserAdminRoleURL, getAllUserRecordsURL, getUserRecordsURL, scrollToTop} from "@/config/app-settings";
import axios from "axios";
import FungusRecordMapPopup from "@/classes/FungusRecordMapPopup";
import {FilterMatchMode} from "primevue/api";

export default defineComponent({
  name: 'Home',
  components: {
    Records, Map
  },
  data() {
    return {
      loading: false,
      lazyParams: {},
      features: [] as FungusRecordMapPopup[],
    }
  },
  beforeMount() {

    this.loading = true
    this.lazyParams = {
      first: 0,
      rows: 100000000, // TODO: this is a workaround to retrieve all records for map display
      filters: {
        'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
      }
    }
    axios.get(checkUserAdminRoleURL).then(res => {
      if (res.data == true) {
        axios.post(getAllUserRecordsURL, this.lazyParams)
            .then(res => {
              this.features = res.data.content
            })
            .finally(() => this.loading = false)
      } else {
        axios.post(getUserRecordsURL, this.lazyParams)
            .then(res => {
              this.features = res.data.content
            })
            .finally(() => this.loading = false)
      }
    })


  }
});
